export interface Lookup {
  id: number;
  name: string;
  nameEN: string;
  isDeleted: true;
}
